import { ReactNode } from 'react';
import { Text } from '../components/Text';

export const Section: React.FC<{title: string, 'data-id'?: string, children: ReactNode}> = ({ title, 'data-id': dataId, children }) => {
    return (
        <div data-id={dataId} style={{marginBottom: 20}}>

            <div style={{padding: 10}}>
                <Text type="title">{title}</Text>
            </div>

            {children}

        </div>
    );
};
